module.exports = __webpack_public_path__ + "static/Business_Icon-224abb160fd5b2df6c0cf9f05fedd66c.png";